export const USER_ACTION = {
    GET_USER_INFO: 'GET_USER_INFO',
    REMOVE_USER_INFO: 'REMOVE_USER_INFO',
    GET_WATCHLIST2: 'GET_WATCHLIST2',
    SET_PREFERENCE: 'SET_PREFERENCE'
}

export const USER_INFO_CONF = {
    internationalPhoneCode: '(+84)',
    timezone: 'Asia/Ho_Chi_Minh'
}